import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function AppHeader() {
  const navigate = useNavigate();
  const { user, isSignedIn, loading, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-30">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-center justify-between">
        <button onClick={() => navigate('/')} className="flex items-center gap-2">
          <img src="/logo.png" alt="" className="h-7 w-auto" />
          <span className="text-lg font-bold text-gray-900">DraftResume</span>
        </button>

        <div className="flex items-center gap-3">
          {loading ? (
            // Hold space until the session check resolves so the right side
            // doesn't flash signed-out controls and then swap to the account
            // menu when getSession returns. Roughly matches the height of
            // both signed-in and signed-out variants.
            <div aria-hidden="true" className="h-9" />
          ) : isSignedIn && user ? (
            <div className="relative">
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="flex items-center gap-2 hover:bg-gray-50 rounded-lg px-3 py-1.5 transition-colors"
              >
                <span className="text-sm font-semibold text-stone-900">{((user.token_balance ?? 0) / 10).toFixed(1)} tokens</span>
                <div className="w-8 h-8 bg-stone-900 text-white rounded-full flex items-center justify-center font-medium text-sm">
                  {user.email?.[0]?.toUpperCase() || 'U'}
                </div>
              </button>
              {menuOpen && (
                <>
                  <div className="fixed inset-0 z-10" onClick={() => setMenuOpen(false)} />
                  <div className="absolute right-0 mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-20">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <p className="text-sm font-medium text-gray-900">{user.email}</p>
                      <p className="text-xs text-gray-500 mt-0.5">
                        <span className="font-semibold text-stone-900">{((user.token_balance ?? 0) / 10).toFixed(1)}</span> tokens remaining
                      </p>
                    </div>
                    <button
                      onClick={() => { setMenuOpen(false); navigate('/app?purchase=true'); }}
                      className="w-full text-left px-4 py-2 text-sm text-stone-900 font-medium hover:bg-orange-50 transition-colors"
                    >
                      Buy Tokens
                    </button>
                    <button
                      onClick={() => { setMenuOpen(false); navigate('/account'); }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                      My Resumes
                    </button>
                    <button
                      onClick={() => { setMenuOpen(false); navigate('/app'); }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                      Builder
                    </button>
                    <div className="px-4 py-2 border-t border-gray-100">
                      <p className="text-xs text-gray-400 mb-1">Share and earn tokens</p>
                      <div className="flex items-center gap-1">
                        <input
                          type="text"
                          readOnly
                          value={`draftresume.app/?ref=${user.promo_code || ''}`}
                          className="flex-1 text-xs bg-gray-50 border border-gray-200 rounded px-2 py-1 text-gray-600 font-mono"
                        />
                        <button
                          onClick={() => navigator.clipboard.writeText(`https://draftresume.app/?ref=${user.promo_code || ''}`)}
                          className="text-xs bg-stone-900 text-white px-2 py-1 rounded hover:bg-stone-800"
                        >
                          Copy
                        </button>
                      </div>
                    </div>
                    <button
                      onClick={async () => { await logout(); setMenuOpen(false); navigate('/'); }}
                      className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50 transition-colors border-t border-gray-100"
                    >
                      Sign Out
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <>
              <button onClick={() => navigate('/login')} className="text-sm text-gray-600 hover:text-gray-900">Sign In</button>
              <button onClick={() => navigate('/app')} className="bg-stone-900 text-white text-sm px-4 py-2 rounded-lg hover:bg-stone-800 font-medium">Try Free</button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
